import { frontendURL } from 'dashboard/helper/URLHelper.js';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';

const ClinicaPage = () => import('./ClinicaPage.vue');

export const routes = [
  {
    path: frontendURL('accounts/:accountId/clinica'),
    name: 'jabvox_clinica_index',
    meta: {
      featureFlag: FEATURE_FLAGS.JABVOX_CLINICA,
      permissions: ['administrator', 'agent'],
    },
    component: ClinicaPage,
  },
];
